import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link } from 'react-router';
import $ from 'jquery';
import moment from 'moment';

import { getUserInfo, getClassInfo, singupLesson } from '../../actions';

import ClassAD from '../../component/classAD';
import Button from '../../component/button';
import Title from '../../component/title';

import { Radio } from 'antd';
const RadioGroup = Radio.Group;

function compareTime(obja, objb) {


    if (moment(obja.start_time).diff(objb.start_time) < 0) {
        return -1;
    }
    if (moment(obja.start_time).diff(objb.start_time) > 0) {
        return 1;
    }
    // a 必須等於 b
    return 0;
}


class Class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lessons: [],
            step: 1,
            classValue:'',
            students: null,
            lesson_id: null
        }

        props.getUserInfo();

        this.chooseClass = (id, e) => {
            //console.log(id);
            this.setState({
                step: this.state.step + 1,
                classValue: e.target.innerText,
                lesson_id: id
            })
        }

        this.radioSelect = (e) => {
            this.setState({students: e.target.value});
        }

        this.radioClick = (name, e) => {
            this.student_name = name;
        }
        
        this.next = (e) => {
            const student_id  = this.state.students;
            const user_id = this.props.userInfo.id;
            const lesson_id = this.state.lesson_id;

            if( this.state.students ) {
                this.props.singupLesson({
                    user_id,
                    student_id,
                    lesson_id
                }).then((res) => {
                    if(!res.error ) {
                        this.props.getUserInfo();
                        this.setState({
                            step: this.state.step + 1,
                            sign_up_id: res.id
                        })
                    }
                    else {
                        alert(res.error.response.body.error.message);
                    }
                })
            }
        }
    }   
    componentDidMount() {
        this.props.getClassInfo({ class_id: this.props.params.class_id });
    }
    componentWillReceiveProps(nextProps) {
        if( this.props.lessonEntity !== nextProps.lessonEntity ) {
            for( var key in nextProps.lessonEntity ) {
                this.state.lessons.push( nextProps.lessonEntity[key] );
            }
            this.setState(this.state.lessons);
        }
    }

    renderTitleByStep(step) {
        const stepMap = [
            '選擇課程日期',
            '確認',
            '報名完成'
        ]
        return <Title styleName={ "step-"+step }>{ stepMap[step - 1] }</Title>;
    }
    renderRightHalfByStep(step) {
        switch(step) {
            case 1:
                const { lessons } = this.state;
                if( !lessons ) return null;
                return this.renderLessons(lessons.sort(compareTime));
            case 2: 
                return this.renderConfirm();
            case 3:
                return this.renderFinal();
        }
    }
    renderLessons(lessons) {
        if ( lessons.length === 0 ) return <p>目前沒有開課資料</p>
        else {
            return (
                lessons.map((object, index) => {
                    const { date, start, end, week, tillNow } = this._generateTime(object);
                    if( object.member_limit <= object.sign_ups.length || object.status === 'suspend') {
                        return tillNow < 0 && tillNow >= -28 &&  <div styleName="circle full" >{`${date} (${week[2]}) ${start}`}</div>;
                    }

                    return tillNow < 0 && tillNow >= -28 && <div styleName="circle" onClick={this.chooseClass.bind(this, object.id)}>{`${date} (${week[2]}) ${start}`}</div>;
                })
            );
        }
    }
    renderConfirm() {
        const { classValue } = this.state;
        const { userInfo, lessonEntity } = this.props;

        return (
            <div styleName="step2">
                <p>{ classValue }</p>
                <p>每個學生使用課程服務點數{ lessonEntity["lesson_"+this.state.lesson_id].cost_point}點</p>
                <br/>
                <br/>
                <br/>
                <p>報名學生：</p>
                <RadioGroup onChange={this.radioSelect} >
                    { userInfo && userInfo.students && userInfo.students.map((object, index)=>{

                        const sign_up_lesson = this.props.studentsEntity["stu_"+object.id].sign_up_status.lessons;
                        const sign_up_time = this.props.studentsEntity["stu_"+object.id].sign_up_status.times;

                        if( sign_up_lesson.find((lesson) => { return lesson == this.state.lesson_id}) ||
                            sign_up_time.find((time) => { return time == lessonEntity["lesson_"+this.state.lesson_id].class_time_id})){
                            return <Radio 
                                        key={index}
                                        value={object.id}
                                        style={{
                                            display: 'block',
                                            margin: '15px'
                                        }}
                                        disabled={true}>{object.name} (此學生已報名過)</Radio>
                        }

                        return <Radio 
                                    key={index}
                                    value={object.id} 
                                    style={{
                                        color: "#333",
                                        display: 'block',
                                        margin: '15px'
                                    }}
                                    onClick={this.radioClick.bind(this, object.name)}
                                    >{object.name}</Radio>
                    }) }
                </RadioGroup>
                <Button styleName="confirm" onClick={this.next}>確認</Button>
            </div>
        );
    }
    renderFinal() {
        const user_type = this.props.userInfo.level == 2 ? 'vip': 'normal';
        const { lessonEntity } = this.props;
        const cost_point = lessonEntity["lesson_"+this.state.lesson_id].cost_point;
        return (
            <div styleName="step2">
                <p>{ this.state.classValue }</p>
                <p>每個學生使用課程服務點數{ cost_point }點</p>
                <br/>
                <br/>
                <br/>
                <p>報名學生：</p>
                <br/>
                {/*{ this.state.students.map((key, index) => <p>{key}</p>) }*/}
                { this.student_name }
                <br/>
                <br/>
                {
                    cost_point == 0 && <p>感謝您的報名，歡迎您來上課。</p>
                }
                {
                    cost_point > 0 && <p>上課後扣點 { cost_point } 點。</p>
                }
            </div>
        );
    }
    render() {
        const { lessons, step } = this.state;
        const { userInfo } = this.props;
        const classInfo = this.props.classEntity["class_"+this.props.params.class_id] || {};
        // const user_type = userInfo && userInfo.level === 2 ? 'vip' : 'normal';

        return (
            <div>
                { this.renderTitleByStep(step)}

                <div styleName="container">

                    <ClassAD { ...classInfo } styleName="left-block"/>
                    
                    <div styleName="right-block">

                        { this.renderRightHalfByStep(step)}

                    </div>
                </div>
            </div>
        );
    }
    _generateTime(data) {
        return {
            date: moment(data.date).format("MM/DD"),
            start: moment(data.start_time).format("HH:mm"),
            end: moment(data.end_time).format("HH:mm"),
            week: moment(data.date).locale('zh-tw').format("dddd", 'zh-tw'),
            timeSpend: moment(data.end_time).subtract(data.start_time).format("HH:mm"),
            tillNow: moment().diff(moment(data.start_time), 'days')
        }
    }
}

const mapStateToProps = state => {
	return { 
        userInfo: state.data.user,
        classEntity: state.data.classEntity,
        lessonEntity: state.data.lessonEntity,
        studentsEntity: state.data.studentsEntity
    };
}

export default connect(mapStateToProps, { getUserInfo, getClassInfo, singupLesson })(CSSModule(Class,style,{allowMultiple:true}));


/** WEBPACK FOOTER **
 ** ./src/container/class/index.js
 **/